export const getRecoverToken = (): string | null => {
  const match = location.href.match(/\/password\/reset\/(\w+)$/);

  if (!match || match?.length < 2) {
    return null;
  }

  return match[1];
};
